<template>
<div class="container">
  <div class="box">
    <h1 class="title">User discount list</h1>

    <table class="table is-bordered is-striped is-fullwidth">
      <thead>
        <tr>
          <th>Group</th>
          <th>Discount</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="index" v-for="(item, index) in companyList">
          <td>{{item.group}}</td>
          <td>{{item.discount}}%</td>
        </tr>
      </tbody>
    </table>

  </div>
</div>
</template>

<script>
import errorHandler from '@/errorHandler';

export default {
  title: 'Discount List • BMI Pricing Calculator',
  data() {
    return {
      companyList: [],
    };
  },

  mounted() {
    this.viewCompanyDiscount();
  },

  methods: {
    viewCompanyDiscount() {
      fetch('/api/discounts', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.companyList = response;
        });
    },
  },
};
</script>
